import AsyncStorage from "@react-native-async-storage/async-storage";
import { Button } from "@ui-kitten/components";
import axios from "axios";
import React, { useEffect, useState, useRef, useLayoutEffect, createRef } from "react";
import Iframe from "react-iframe";
import { View, Text, Image, ScrollView, TouchableOpacity, Dimensions } from "react-native";
import { Icon } from "react-native-eva-icons";
import RenderHtml from "react-native-render-html";
import Swiper from "react-native-web-swiper";
import { useNavigate, useParams } from "react-router-native";
import { useToast } from "react-native-toast-notifications";
import DocListItem from "../../../components/documents/doclistitem";
import Map from "../../../components/map";
import Swal from "sweetalert2";
import ReactPlayer from "react-player";
import { BlurView } from "expo-blur";
import {APIadminsURL} from "@env";
// CommonJS

//pics: ${APIadminsURL}/img/investments/h1.jpg
function Dataroom() {
  const thisRef = React.createRef();
  const width = Dimensions.get("window").width;

  const [myoverflow, setmyoverflow] = useState(false);
  useLayoutEffect(() => {
    if (thisRef?.current?.clientWidth < thisRef?.current?.scrollWidth) {
      setmyoverflow(true);
    }
  }, [thisRef]);
  const scroll = (scrollOffset) => {
    thisRef.current.scrollLeft += scrollOffset;
  };

  const Swal = require("sweetalert2");
  const [data, setData] = useState();
  const [subscriptionStatus, setSubscriptionStatus] = useState("");
  const [subscription, setSubscription] = useState(0);
  const [approvement, setApprovement] = useState(null);
  const [Contribution_status, setContribution_status] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [DRoom, setDRoom] = useState(false);
  const [CheckDRoom, setCheckDRoom] = useState(false);

  const [docs, setDocs] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const swiperRef = useRef(null);
  const ismobile = width < 750;
  const toast = useToast();
  const { dataRoom } = useParams();
  function RequestSubscription(idInvestment) {
    let Data = { test: "" };
    AsyncStorage.getItem("token").then((token) => {
      if (token !== null) {
        axios
          .post(
            `${APIadminsURL}/public/api/subscription/request/` + idInvestment,
            Data,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then((res) => {
            Swal.fire({
              title: "Success!",
              text: res.data.message,
              icon: "success",
            });
            toast.show(res.data.message, {
              type: "success",
              placement: "bottom",
            });
          })
          .catch((res) => {
            console.log("error");
          });
      }
    });
  }
  function currency(num) {
    return num.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });
  }
  /* useEffect(()=>{
    alert(width);
  },[width]) */
  useEffect(() => {
    if (window.location.href.search("Dataroom") != -1) {
      //alert(window.location.href.search("Dataroom"));

      //alert(dataRoom);
      axios
        .get(`${APIadminsURL}/api/CheckDataRoom/` + dataRoom)
        .then((res) => {
          if (res.data.message == true) {
            axios
              .get(`${APIadminsURL}/api/investmentDataroom/` + id)
              .then((res) => {
                //achraf
                setSubscriptionStatus(res.data.investment.subscription_status);
                setSubscription(res.data.investment.subscription);
               setApprovement(res.data.investment.approvement);
                setData(res.data.investment);
                setDRoom(true);
                axios
                  .get(`${APIadminsURL}/api/documentsDataroom/` + id)
                  .then((result) => {
                    setDocs(result.data);
                  })
                  .catch((er) => {
                  });
              })
              .catch((res) => {
                if (res.response.status === 401) {
                  navigate("/login?redirect_id=" + id);
                }
              });
          } else {
            setCheckDRoom(true);
          }
        })
        .catch(() => {});
    } else {
      AsyncStorage.getItem("token").then((token) => {
        if (token !== null) {

          axios
            .get(`${APIadminsURL}/public/api/investment/` + id, {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
              setSubscriptionStatus(res.data.investment.subscription_status);
              setSubscription(res.data.investment.subscription);
              setApprovement(res.data.investment.approvement);
              setContribution_status(res.data.investment.Contribution_status);
              setData(res.data.investment);
              axios
                .get(`${APIadminsURL}/public/api/documents/` + id, {
                  headers: { Authorization: `Bearer ${token}` },
                })
                .then((result) => {
                  setDocs(result.data);
                })
                .catch((er) => {
                });
            })
            .catch((res) => {
              if (res.response.status === 401) {
                navigate("/login?redirect_id=" + id);
              }
            });
        } else {
          navigate("/login?redirect_id=" + id);
        }
      });
    }
  }, []);

  if ((!data || !docs) && CheckDRoom == false) return <Text>Loading</Text>;
  else if (CheckDRoom == false && DRoom == false && data.visibility == 0)
    return (
      <>
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#f7f8fa",
          }}>
          <Text style={{ fontSize: 20, fontFamily: "Roboto_700Bold", color: "#909398" }}>
            S7 Equity has not published the data room of this investment yet
          </Text>
        </View>
      </>
    );
  else if (CheckDRoom == true)
    return (
      <>
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#f7f8fa",
          }}>
          <Text style={{ fontSize: 20, fontFamily: "Roboto_700Bold", color: "#909398" }}>
            The preview link has expired
          </Text>
        </View>
      </>
    );
  return (
    <>
      <ScrollView style={{ backgroundColor: "#f3f3f3", overflow: "hidden" }}>
        <View
          style={{
            width: "90%",
            flexDirection: ismobile ? "column" : "row",
            alignSelf: "center",
            marginTop: 100,
          }}>
          <View
            style={{
              flex: ismobile ? "" : 2,
              minWidth: ismobile ? 0 : 440,
              height: ismobile ? 260 : 400,
            }}>
            <View
              style={{ flexDirection: ismobile ? "column" : "row", width: "100%", height: "100%" }}>
              <Swiper
                ref={swiperRef}
                containerStyle={{ flex: data.images.length > 0 ? 3 : 1 }}
                controlsProps={{
                  dotActiveStyle: { backgroundColor: "#8DC641" },
                  nextTitleStyle: { color: "#8DC641" },
                  prevTitleStyle: { color: "#8DC641" },
                  dotsTouchable: true,
                  prevTitle: "Previous",
                }}
                timeout={5}
                loop>
                {data.images.map((img, key) => {
                  return (
                    <Image
                      key={key}
                      style={{ width: "100%", height: "100%", borderRadius: 0 }}
                      source={{
                        uri: `${APIadminsURL}/img/investments/${img.thumb}`,
                      }}
                    />
                  );
                })}

                {data.images.length > 0 ? null : (
                  <Image
                    source={{
                      uri: data.cover
                        ? `${APIadminsURL}/img/investments/` + data.cover
                        : "https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500  ",
                    }}
                    style={{ width: "100%", height: "100%", borderRadius: 0 }}
                  />
                )}
              </Swiper>
              {data.images.length > 0 ? (
                <ScrollView
                  horizontal={ismobile}
                  contentContainerStyle={{
                    marginTop: ismobile ? 30 : -15,

                    flex: 1,
                    height: ismobile ? 0 : "110%",
                    flexDirection: ismobile ? "row" : "column",
                  }}>
                  {data.images.map((img, key) => {
                    return (
                      <TouchableOpacity
                        style={{
                          alignSelf: "center",
                          width: ismobile ? 125 : "100%",
                          height: "auto",
                        }}
                        onPress={() => {
                          swiperRef.current.goTo(key);
                        }}>
                        <Image
                          key={key}
                          style={{
                            width: ismobile ? 120 : "90%",
                            height: ismobile ? 70 : 128,
                            borderRadius: 0,
                            marginRight: 10,
                            marginLeft: ismobile ? 0 : 10,
                            marginBottom: 0,
                            marginTop: ismobile ? 20 : 10,
                          }}
                          source={{
                            uri: `${APIadminsURL}/img/investments/${img.thumb}`,
                          }}
                        />
                      </TouchableOpacity>
                    );
                  })}
                </ScrollView>
              ) : null}
            </View>
          </View>

          {/* ------------//info -------------------- */}
          <View
            style={{
              flex: 1,
              height: ismobile ? "auto" : 400,
              marginLeft: ismobile ? 0 : 20,
              marginBottom: ismobile ? 20 : 0,
              marginTop: ismobile ? 12 : 0,
              flexDirection: "column",
              justifyContent: "space-between",
              minWidth: 180,
            }}>
            <Text
              style={{
                fontFamily: "Roboto_700Bold",
                fontSize: ismobile ? "6vw" : 35,
              }}>
              {data.name}{" "}
              <Icon name="arrow-forward-outline" width={20} height={20} fill="#969696" />
            </Text>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}>
              <Icon name="pin-outline" width={28} height={28} fill="#8DC641" />
              <Text
                style={{
                  fontFamily: "Roboto_500Medium",
                  color: "#8DC641",
                  marginLeft: 10,
                  fontSize: ismobile ? "4vw" : 20,
                }}>
                {data.street_name ? data.street_name + ", " :""}
                
                {data.province ? data.province + ", " :""}
              
                {data.city ? data.city + ", " :""}
                
                {data.country ? data.country :""}
              </Text>
            </View>
            <View
              style={{
                flexDirection: ismobile ? "column" : "row",
                alignItems: "left",
                marginTop: ismobile ? 10 : 16,
              }}>
              {data.sponsors.map((sponsor, key) => {
                if (sponsor.co_percentage) {
                  return [
                    <View
                    key={key} 
                      style={{
                        flexDirection: "row",
                        alignItems: "left",
                        textAlignVertical: "center",
                      }}>
                      <Text
                        style={{
                          color: "#969696",
                          fontFamily: "Roboto_400Regular",
                          alignSelf: "flex-start",
                          fontSize: ismobile ? "4vw" : 18,
                          margin: ismobile ? 5 : 0,
                        }}>
                        Sponsor Co-Invest:
                      </Text>
                      {data.sponsors.map((sponsor, key) => {
                        return [
                          <Text
                          key={key} 
                            style={{
                              color: "#969696",
                              fontFamily: "Roboto_400Regular",
                              alignSelf: "flex-start",
                              fontSize: ismobile ? "4vw" : 18,
                              paddingLeft: 5,
                              margin: ismobile ? 5 : 0,
                            }}>
                            {sponsor.co_percentage}%,
                          </Text>,
                        ];
                      })}
                    </View>,
                  ];
                }
              })}
              {data.hold_time !== null && (
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <Text
                    style={{
                      color: "#969696",
                      fontFamily: "Roboto_400Regular",
                      alignSelf: "flex-start",
                      fontSize: ismobile ? "4vw" : 18,
                      paddingLeft: 5,
                    }}>
                    Holding Period:
                  </Text>
                  <Text
                    style={{
                      color: "#969696",
                      fontFamily: "Roboto_400Regular",
                      alignSelf: "flex-start",
                      fontSize: ismobile ? "4vw" : 18,
                      paddingLeft: 5,
                    }}>
                    {data.hold_time ==1 ? data.hold_time + " month" : data.hold_time + " months"}
                  </Text>
                </View>
              )}
            </View>

            <View
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 12,
                marginTop: 12,
              }}>
              <Icon
                name="clock-outline"
                style={{ flex: 0.1 }}
                width={20}
                height={20}
                fill="#8DC641"
              />
              <Text
                style={{
                  flex: myoverflow == true ? 0.4 : 1,
                  fontFamily: "Roboto_500Medium",
                  color: "#8DC641",
                  marginLeft: 10,
                  fontSize: ismobile ? "4vw" : 15,
                }}>
                Open for investing
              </Text>
              {(() => {
                if (myoverflow == true) {
                  return (
                    <Icon
                      onClick={() => scroll(-50)}
                      name="arrow-left-outline"
                      width={20}
                      height={20}
                      fill="#969696"
                    />
                  );
                }
              })()}
               {(() => {
                if (data.ownership == "shares001") {
                  return (
              <View
                ref={thisRef}
                style={{
                  overflowX: "hidden",
                  flex: 0.5,
                  display: "flex",
                  flexDirection: "row",
                  position: "unset",
                  right: 20,
                  alignItems: "flex-end",
                }}>
                  
                {data.types.map((type, key) => {
                  return (
                    <View
                      key={key}
                      style={{
                        height: 30,
                        backgroundColor: "#e7ede0",
                        borderRadius: 5,
                        paddingHorizontal: 15,
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: "0.6em",
                      }}>
                      <Text style={{ fontFamily: "Roboto_400Regular", fontSize: 11 }}>{type}</Text>
                    </View>
                  );
                })}
                
              </View>
              );
            }else{
              return (
                <View
                ref={thisRef}
                style={{
                  overflowX: "hidden",
                  flex: 0.5,
                  display: "flex",
                  flexDirection: "row",
                  position: "unset",
                  right: 20,
                  alignItems: "flex-end",
                }}>
                    {data.project_type && <View
                          style={{
                            height: 30,
                            backgroundColor: "#e7ede0",
                            borderRadius: 5,
                            paddingHorizontal: 15,
                            justifyContent: "center",
                            alignItems: "center",
                            marginLeft: "0.6em",
                          }}>
                          <Text style={{ fontFamily: "Roboto_400Regular", fontSize: 11 }}>{data.project_type}</Text>
                      
                        </View>}
                        {data.project_subtype &&  <View
                        style={{
                          height: 30,
                          backgroundColor: "#e7ede0",
                          borderRadius: 5,
                          paddingHorizontal: 15,
                          justifyContent: "center",
                          alignItems: "center",
                          marginLeft: "0.6em",
                        }}>
                          <Text style={{ fontFamily: "Roboto_400Regular", fontSize: 11 }}>{data.project_subtype}</Text>
                      </View>}

                </View>
              );
            }
          })()}
              {(() => {
                if (myoverflow) {
                  return (
                    <Icon
                      onClick={() => scroll(50)}
                      name="arrow-right-outline"
                      width={20}
                      height={20}
                      fill="#969696"
                    />
                  );
                }
              })()}
            </View>

            {data.sponsors.length > 0 && (
              <View
                style={{
                  backgroundColor: "#eeeff0",
                  borderRadius: 15,
                  display: "flex",
                  flexWrap: "wrap",
                  flexDirection: "row",
                  alignItems: "left",
                  height: "auto",
                  padding: 20,
                  paddingLeft: "2.3em",
                  marginBottom: 12,
                  marginTop: 12,
                }}>
                {data.sponsors.map((sponsor, key) => {
                  return [
                    <View
                    key={1111+key} 
                      style={{
                      
                      }}>
                    <Image
                      key={key}
                      style={{ height: "2em", width: "4em", paddingRight: "15px" }}
                      source={{
                        uri: `${APIadminsURL}/public/img/sponsors/${sponsor.logo}`,
                      }}
                    /></View>,
                    <View
                    key={295+key} 
                      style={{
                     
                      }}>
                    <Text
                      style={{
                        fontFamily: "Roboto_500Medium",
                        fontSize: 28,
                      
                      }}>
                      {sponsor.name}
                    </Text></View>,
                    <View key={22222+key}  >
                      {!ismobile && data.sponsor_tags.map((stag, key) => {
                        return (
                          <View
                            key={key+9999}
                            style={{
                              height: 30,
                              backgroundColor: "#dcddde",
                              borderRadius: 5,
                              paddingHorizontal: 15,
                              justifyContent: "center",
                              alignItems: "center",
                              marginLeft: "0.6em",
                            }}>
                            <Text style={{ fontFamily: "Roboto_400Regular", fontSize: 11 }}>
                              {stag}
                            </Text>
                          </View>
                        );
                      })}
                      
            
                    </View>,
                  ];
                })}
              </View>
            )}
            {(() => {
              if (DRoom == true) {
                return (
                  <Button style={{ borderRadius: 10 }} status="info">
                    Invest Now
                  </Button>
                );
              } else if (
                (subscriptionStatus == "Declined" || subscriptionStatus == "Not Granted") &&
                DRoom == false
              ) {
                return (
                  <Button
                    onPress={() => {
                      RequestSubscription(data.id);

                      // navigate("/start/" + data.id);
                    }}
                    style={{ borderRadius: 10 }}
                    status="info">
                    Invest Now
                  </Button>
                );
              } else if (subscription == 0 && subscriptionStatus == "Granted" && DRoom == false) {
                return (
                  <Button
                    onPress={() => {
                      navigate("/start/" + data.id);
                    }}
                    style={{ borderRadius: 10 }}
                    status="info">
                    Invest Now
                  </Button>
                );
              } else if (
                approvement != "under review" &&
                approvement != "Approved" &&
                subscription != 0 &&
                subscriptionStatus == "Granted" &&
                DRoom == false
              ) {
                return (
                  <Button
                    onPress={() => {
                      navigate("/subscription/" + data.id + "/" + subscription);
                    }}
                    style={{ borderRadius: 10 }}
                    status="info">
                    {approvement == "Request modification"
                      ? "Update my investment"
                      : "Complete my investment"}
                  </Button>
                );
              } else if (
                approvement == "Approved" &&
                subscription != 0 &&
                subscriptionStatus == "Granted" &&
                DRoom == false
              ) {
                return (
                  <Button
                    onPress={() => {
                      navigate("/summary/" + data.id + "/" + subscription);

                      //navigate("/subscription/" + data.id + "/" + subscription);
                    }}
                    style={{ borderRadius: 10 }}
                    status="info">
                  {(Contribution_status=="sent"||Contribution_status=="completed") ? "Summary": "Pay Now" }
                  </Button>
                );
              } else if (
                approvement == "under review" &&
                subscription != 0 &&
                subscriptionStatus == "Granted" &&
                DRoom == false
              ) {
                return (
                  <Button
                    onPress={() => {
                      navigate("/summary/" + data.id + "/" + subscription);
                    }}
                    style={{ borderRadius: 10 }}
                    status="info">
                    Under review
                  </Button>
                );
              } else {
                return (
                  <Button
                    onPress={() => {
                      if (DRoom == false) {
                        RequestSubscription(data.id);
                      }
                      // navigate("/start/" + data.id);
                    }}
                    style={{ borderRadius: 10 }}
                    status="info">
                    Request subscription package
                  </Button>
                );
              }
            })()}
          </View>

          {/* ------------//info -------------------- */}
        </View>

        {/* ------------new row1 -------------------- */}
        <View
          style={{
            width: "90%",
            flexDirection: ismobile ? "column" : "row",
            alignSelf: "center",
          }}>
          {/* ------------column1 -------------------- */}
          <View
            style={{
              flex: ismobile ? "none" : 0.65, //0.33 //0.67

              marginTop: ismobile ? 20 : 20,
            }}>
            {/* ------------Additional Information if mobile -------------------- */}
            {(() => {
              if (ismobile) {
                return (
                  <View
                    style={{
                      backgroundColor: "#fff",
                      height: "auto",
                      maxHeight: 450,
                      marginLeft: ismobile ? 0 : 20,
                      borderRadius: 15,
                      padding: 25,
                      marginTop: 20,
                      minWidth: 180,
                    }}>
                    <View>
                      <Text
                        style={{
                          fontSize: 24,
                          color: "#333",
                          fontFamily: "Roboto_700Bold",
                          marginBottom: 20,
                        }}>
                        Additional Information
                      </Text>
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                          marginTop: 12,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Targeted Investment ROI:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.ROI ? data.ROI + "%" : "---"}
                        </Text>
                      </View>
                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Targeted Equity Multiple:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.total_equity ? data.total_equity + "x" : "---"}
                        </Text>
                      </View>

                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Targeted Investment Period:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.hold_time ? (data.hold_time ==1 ? data.hold_time + " month" : data.hold_time + " months") : "---"}
                        </Text>
                      </View>

                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Minimum Investment:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.min_invest ? currency(data.min_invest) : "---"}
                        </Text>
                      </View>
                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Funding Target:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.display_raise == 0
                            ? "---"
                            : data.equity_goal
                            ? currency(data.equity_goal)
                            : "---"}
                        </Text>
                      </View>
                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Investment Start Date:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.start_date
                            ? data.start_date
                            : "---"}
                        </Text>
                      </View>
                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Investment Due Date:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.closing_date 
                            ?  data.closing_date
                           
                            : "---"}
                        </Text>
                      </View>
                    </View>
                  </View>
                );
              }
            })()}
            {/* ------------//Additional Information if mobile -------------------- */}
            {/* ------------Video1 -------------------- */}
            {(() => {
              ///////////row 1
              if (data.video_url !== null || data.video !== null) {
                return (
                  <View
                    style={{
                      backgroundColor: "#fff",
                      minWidth: ismobile ? 180 : 450,
                      minHeight: ismobile ? 280 : 450,
                      borderRadius: 15,
                      paddingVertical: 25,
                      paddingHorizontal: 20,
                      marginTop: ismobile ? 20 : 20,
                    }}>
                    <Text
                      style={{
                        fontSize: 24,
                        color: "#333",
                        fontFamily: "Roboto_700Bold",
                        marginBottom: 10,
                        marginLeft: 20,
                      }}>
                      Video
                    </Text>

                    <ReactPlayer
                      url={
                        data.video_type === "file"
                          ? `${APIadminsURL}/videos/` + data.video
                          : data.video_url
                      }
                      height="100%"
                      width="100%"
                      light
                      playing={isPlaying}
                      onReady={() => {
                        setIsPlaying(true);
                      }}
                      playIcon={
                        <BlurView
                          intensity={20}
                          style={{
                            width: "100%",
                            height: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                          }}>
                          <View
                            style={{
                              width: "100%",
                              height: "100%",
                              backgroundColor: "#ffffff80",
                              justifyContent: "center",
                              alignItems: "center",
                            }}>
                            <svg
                              style={{ fill: "rgba(141,198,65,1)", width: 82, height: 82 }}
                              viewBox="4 4 122 122">
                              <path
                                style={{
                                  overflow: "visible",
                                  position: "absolute",
                                  transform: "matrix(1,0,0,1,0,0)",
                                }}
                                d="M 50.20750045776367 90.92500305175781 L 90.92500305175781 65.00000762939453 L 50.20750045776367 39.07500076293945 L 50.20750045776367 90.92500305175781 Z M 65.00000762939453 126.0000076293945 C 56.66333770751953 126.0000076293945 48.78416442871094 124.3987503051758 41.36250305175781 121.1962509155273 C 33.94083404541016 117.9937591552734 27.4595832824707 113.6220779418945 21.91875076293945 108.0812530517578 C 16.37791442871094 102.5404357910156 12.00625133514404 96.05918121337891 8.803750038146973 88.63750457763672 C 5.601249694824219 81.21583557128906 4 73.336669921875 4 65.00000762939453 C 4 56.56166458129883 5.601249694824219 48.63166809082031 8.803750038146973 41.21000289916992 C 12.00625133514404 33.78833389282227 16.37791442871094 27.3325023651123 21.91875076293945 21.84250068664551 C 27.4595832824707 16.35250091552734 33.94083404541016 12.00625228881836 41.36250305175781 8.803751945495605 C 48.78416442871094 5.601250648498535 56.66333770751953 4 65.00000762939453 4 C 73.43833923339844 4 81.36833953857422 5.601249694824219 88.79000854492188 8.803750038146973 C 96.21167755126953 12.00625133514404 102.6675033569336 16.35250091552734 108.1575012207031 21.84250068664551 C 113.6475067138672 27.3325023651123 117.9937591552734 33.788330078125 121.1962509155273 41.21000289916992 C 124.3987503051758 48.63166809082031 126.0000076293945 56.56166458129883 126.0000076293945 65.00000762939453 C 126.0000076293945 73.336669921875 124.3987503051758 81.21583557128906 121.1962509155273 88.63750457763672 C 117.9937591552734 96.05918121337891 113.6475067138672 102.5404357910156 108.1575012207031 108.0812530517578 C 102.6675033569336 113.6220779418945 96.211669921875 117.9937591552734 88.79000091552734 121.1962509155273 C 81.36833190917969 124.3987503051758 73.43833923339844 126.0000076293945 65.00000762939453 126.0000076293945 Z M 65.00000762939453 116.8500137329102 C 79.43666839599609 116.8500137329102 91.68750762939453 111.7920989990234 101.7525100708008 101.6762619018555 C 111.8175048828125 91.56041717529297 116.8500137329102 79.33500671386719 116.8500137329102 65.00000762939453 C 116.8500137329102 50.56333541870117 111.8175048828125 38.3125 101.7525100708008 28.24750137329102 C 91.68750762939453 18.18249893188477 79.43666839599609 13.14999961853027 65.00000762939453 13.14999961853027 C 50.66500091552734 13.14999961853027 38.43959045410156 18.18249893188477 28.32375335693359 28.24750137329102 C 18.20791625976562 38.3125 13.14999961853027 50.56333541870117 13.14999961853027 65.00000762939453 C 13.14999961853027 79.33500671386719 18.20791625976562 91.56041717529297 28.32375335693359 101.6762619018555 C 38.43959045410156 111.7920989990234 50.66500091552734 116.8500137329102 65.00000762939453 116.8500137329102 Z M 65.00000762939453 65.00000762939453 Z"></path>
                            </svg>
                          </View>
                        </BlurView>
                      }
                    />
                  </View>
                );
              }
            })()}
            {/* ------------//Video -------------------- */}

            {/* ------------//Description -------------------- */}
            {(() => {
              ///////////row 2
              if (
                data.description !== null &&
                data.description !== "<div><br></div>" &&
                data.description !== ""
              ) {
                return (
                  <View
                    style={{
                      backgroundColor: "#fff",
                      minWidth: ismobile ? 180 : 440,
                      borderRadius: 15,
                      padding: 25,
                      marginTop: 20,
                    }}>
                    <Text
                      style={{
                        fontSize: 24,
                        color: "#333",
                        fontFamily: "Roboto_700Bold",
                        marginBottom: 15,
                      }}>
                      Description
                    </Text>
                    <RenderHtml source={{ html: data.description }} />
                  </View>
                );
              }
            })()}
            {/* ------------Description -------------------- */}

            {/* ------------Map -------------------- */}
            {(() => {
              ///////////row 3
              if (
                
                data.longitude !== null &&
                data.latitude !== null
              ) {
                return (
                  <View
                    style={{
                      backgroundColor: "#fff",
                      width: ismobile ? (90 * width) / 100 : "100%",
                      height: 600,
                      borderRadius: 15,
                      alignSelf: "flex-start",
                      padding: 25,
                      marginBottom: 0,
                      marginTop: 20,
                      paddingBottom: 90,
                      position: "relative",
                      //left: "5%",
                    }}>
                    <Text
                      style={{
                        fontFamily: "Roboto_500Medium",
                        fontSize: 24,
                        marginBottom: 10,
                        color: "#3a3b3c",
                      }}>
                      Map
                    </Text>
                    <Text
                      style={{
                        fontFamily: "Roboto_500Medium",
                        color: "#c6c7c8",
                        fontSize: 16,
                        marginBottom: 15,
                        marginTop: 5,
                      }}>
                      {data.street_name ? data.street_name + ", " : "" }
              
                      {data.province ? data.province + ", " : ""}
                   
                      {data.city ? data.city + ", " : ""}
                  
                      {data.country ? data.country : ""}
                    </Text>
                    <Text
                      style={{
                        fontFamily: "Roboto_400Regular",
                        fontSize: 16,
                        marginBottom: 15,
                        marginTop: 5,
                      }}>
                      {data.map_caption}
                    </Text>
                    <Map longitude={data.longitude} latitude={data.latitude} />
                  </View>
                );
              }
            })()}
            {/* ------------//Map -------------------- */}
          </View>

          {/* ------------//column1 -------------------- */}
          {/* ------------column2 -------------------- */}
          <View
            style={{
              flex: ismobile ? "none" : 0.35,
              height: "auto",

              marginTop: 20,
            }}>
            {/* ------------Additional Information if not mobile -------------------- */}
            {(() => {
              if (!ismobile) {
                return (
                  <View
                    style={{
                      backgroundColor: "#fff",
                      height: "auto",
                      maxHeight: 450,
                      marginLeft: ismobile ? 0 : 20,
                      borderRadius: 15,
                      padding: 25,
                      marginTop: 20,
                      minWidth: 180,
                    }}>
                    <View>
                      <Text
                        style={{
                          fontSize: 24,
                          color: "#333",
                          fontFamily: "Roboto_700Bold",
                          marginBottom: 20,
                        }}>
                        Additional Information
                      </Text>
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                          marginTop: 12,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Targeted Investment ROI:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.ROI ? data.ROI + "%" : "---"}
                        </Text>
                      </View>
                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Targeted Equity Multiple:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.total_equity ? data.total_equity + "x" : "---"}
                        </Text>
                      </View>
                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Targeted Investment Period:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.hold_time ? (data.hold_time ==1 ? data.hold_time + " month" : data.hold_time + " months") : "---"}
                        </Text>
                      </View>

                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Minimum Investment:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.min_invest ? currency(data.min_invest) : "---"}
                        </Text>
                      </View>
                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Funding Target:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.display_raise == 0
                            ? "---"
                            : data.equity_goal
                            ? currency(data.equity_goal)
                            : "---"}
                        </Text>
                      </View>
                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Investment Start Date:
                        </Text>
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.start_date
                            ? data.start_date
                            : "---"}
                        </Text>
                      </View>
                      <View
                        style={{ width: "100%", borderColor: "#969696", borderBottomWidth: 1 }}
                      />
                      <View
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "row",
                          height: 50,
                        }}>
                        <Text
                          style={{
                            fontFamily: "Roboto_400Regular",
                            color: "#969696",
                            fontSize: 15,
                            fontWeight: 500,
                          }}>
                          Investment Due Date:
                        </Text>
                        
                        <Text style={{ fontFamily: "Roboto_500Medium", fontSize: 18 }}>
                          {data.closing_date 
                            ?  data.closing_date
                           
                            : "---"}
                        </Text>
                      </View>
                    </View>
                  </View>
                );
              }
            })()}
            {/* ------------//Additional Information if not mobile-------------------- */}
            {/* ------------//Documents -------------------- */}
            <View
              style={{
                backgroundColor: "#fff",
                marginLeft: ismobile ? 0 : 20,
                minWidth: 180,
                borderRadius: 15,
                padding: 25,
                marginTop: ismobile ? 0 : 20,
              }}>
              <Text
                style={{
                  fontSize: 24,
                  color: "#333",
                  fontFamily: "Roboto_700Bold",
                  marginBottom: 20,
                }}>
                Documents
              </Text>
              <View
                style={{
                  flexDirection: "column",
                  height: "90%",
                }}>
                {(() => {
                  ///////////row 2
                  if (docs.length == 0) {
                    return (
                      <Text
                        style={{
                          fontFamily: "Roboto",
                          color: "#969696",
                          fontSize: 15,
                          fontWeight: 500,
                        }}>
                        S7 Equity has not uploaded any documents yet
                      </Text>
                    );
                  }
                })()}
                {docs &&
                  docs.map((doc, key) => {
                    return (
                      <DocListItem
                        compact
                        key={key}
                        type={doc.extension}
                        name={doc.display_name ?? doc.name}
                        date={doc.created_at.split("T")[0]}
                        url={`${APIadminsURL}/public/api` + doc.path.replace("/documents/", "/api_get_document/")}
                        size={doc.size}
                      />
                    );
                  })}
              </View>
            </View>
            {/* ------------//Documents -------------------- */}
          </View>
          {/* ------------//column2 -------------------- */}
        </View>

        {/* ------------//new row1 -------------------- */}

       
       

        <View style={{ height: 100, width: 1 }} />

      </ScrollView>
    </>
  );
  
}

export default Dataroom;
function OverviewData({ title, data }) {
  return (
    <View
      style={{
        flexDirection: "row",
        flex: 1,
        flexWrap: "nowrap",
        borderColor: "#e9e9e9",
        borderBottomWidth: 1,
        alignItems: "center",
      }}>
      <Text
        style={{
          fontFamily: "Roboto_500Medium",
          flex: 2,
          marginRight: 20,
          textAlign: "Left",
          color: "#969696",
        }}>
        {title}:
      </Text>
      <Text style={{ flex: 1, textAlign: "left" }}>{data}</Text>
    </View>
  );
}

function getFormatedStringFromDays(numberOfDays) {
  const years = Math.floor(numberOfDays / 365);
  const months = Math.floor((numberOfDays % 365) / 30);
  const days = Math.floor((numberOfDays % 365) % 30);

  const yearsDisplay = years > 0 ? years + (years === 1 ? " year, " : " years, ") : "";
  const monthsDisplay = months > 0 ? months + (months === 1 ? " month, " : " months, ") : "";
  const daysDisplay = days > 0 ? days + (days === 1 ? " day" : " days") : "";
  const res = yearsDisplay + monthsDisplay + daysDisplay;
  return res.replace(/, $/, "");
}
